export const FFC_LOCAL_STORAGE = "viewFulfillmentCenters";
export const IN_STOCK_PRODUCTS_LOCAL_STORAGE = "viewInStockProducts";
export const PURCHASED_BEFORE_LOCAL_STORAGE = "viewPurchasedBeforeProducts";
export const USER_ID_LOCAL_STORAGE = "user-id";
export const NAVIGATION_OUTLINE = "navigationOutline";
export const PRODUCT_COMPARE_LIST_IDS_LOCAL_STORAGE = "productCompareListIds";
export const CONFIG_PRODUCTS_TO_COMPARE_LOCAL_STORAGE = "configProductsToCompare";
export const LOCAL_PRODUCT_CONFIGURATIONS_LOCAL_STORAGE = "localProductConfigurations";
export const INITIALIZE_APP_CACHE_KEY_PREFIX = "vc:initialStore:v1:";
